"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageOptionsDto = void 0;
const order_enum_1 = require("../enums/order.enum");
class PageOptionsDto {
    constructor() {
        this.order = order_enum_1.Order.ASC;
        this.page = 1;
        this.take = 10;
        this.loadRelations = [];
    }
}
exports.PageOptionsDto = PageOptionsDto;
